import {
    DASHBOARD_INFO_REQUEST,
    DASHBOARD_INFO_RESPONSE,
    DASHBOARD_INFO_CACHED_RESPONSE,
    DASHBOARD_INFO_ERROR_RESPONSE,
    DASHBOARD_KNOWLEDGE_SEARCH_REQUEST,
    DASHBOARD_KNOWLEDGE_PAGE_REQUEST,
    DASHBOARD_KNOWLEDGE_RESPONSE
} from "./action-types"
import {
    listPageRequest,
    listSearchRequest,
    listResponse,
    defaultAction
} from "./default-actions/presentation-actions"

export const dashboardInfoRequest = defaultAction(DASHBOARD_INFO_REQUEST)

export const dashboardInfoResponse = data => ({
    type: DASHBOARD_INFO_RESPONSE,
    data,
    receivedAt: Date.now()
})

export const dashboardInfoCachedResponse = defaultAction(
    DASHBOARD_INFO_CACHED_RESPONSE
)

export const dashboardInfoErrorResponse = error => ({
    type: DASHBOARD_INFO_ERROR_RESPONSE,
    error
})

const dashboardKnowledgeResponse = listResponse(DASHBOARD_KNOWLEDGE_RESPONSE)

export const dashboardKnowledgePageRequest = listPageRequest(
    DASHBOARD_KNOWLEDGE_PAGE_REQUEST,
    dashboardKnowledgeResponse
)

export const dashboardKnowledgeInvalidationRequest = pagingRequest =>
    dashboardKnowledgePageRequest({
        ...pagingRequest,
        isInvalidating: true,
        offset: 0,
        nextOffset: 0
    })

export const dashboardKnowledgeSearchRequest = listSearchRequest(
    DASHBOARD_KNOWLEDGE_SEARCH_REQUEST,
    dashboardKnowledgeResponse
)
